import { type TPromoPinConfig } from '../types/PromoPinConfig';

export const Y_MAP_EMBEDDED_MODULES: string[] = [
  'Map',
  'ObjectManager',
  'shape.Rectangle',
  'geometry.pixel.Rectangle',
  'geolocation',
  'hotspot.Layer',
  'GeoObject',
  'templateLayoutFactory',
  'Balloon',
  'util.bounds',
  'Polygon',
];

export const Y_MAP_ALL_MODULES: string[] = [
  ...Y_MAP_EMBEDDED_MODULES,
  'PinsLayer',
  'BalloonManager',
  'HotspotsLayer',
  'cian.DrawPolygon',
];

// По умолчанию, если не получили настройки карты с бэка, то ставим центр Москвы
export const Y_MAP_DEFAULT_STATE: YMaps.IMapState = {
  center: [55.755381, 37.619044],
  controls: [],
  zoom: 10,
};

/**
 * @description
 * Отступ от краев карты в пикселях.
 * Задается аналогично css margin.
 */
export const Y_MAP_DEFAULT_MARGIN: number[] = [24, 16, 24, 16];

export const Y_MAP_DEFAULT_OPTIONS: YMaps.IMapOptions = {
  autoFitToViewport: 'always',
  avoidFractionalZoom: true,
  layerLoadTilesInAction: true,
  restrictMapArea: [
    [41.1859, 19.6389],
    [81.8569, -168.9978],
  ],
  suppressMapOpenBlock: true,
  yandexMapAutoSwitch: false,
  yandexMapDisablePoiInteractivity: true,
  maxZoom: 20,
};

export const TILE_SIZE = 256;

// Сдвиг балуна по вертикали относительно пина
export const BALLOON_OFFSET_TOP = 8;

/**
 * @description
 * Параметры z-index для балунов
 */
export const BALLOON_HOVERED_Z_INDEX = 700;
export const BALLOON_Z_INDEX = 1;

export const MAP_ZOOMING_OPTIONS: YMaps.ISetCenterOptions = {
  duration: 500,
  timingFunction: 'ease-in-out',
};

export const MAP_ZOOM_DURATION = 200;

export const DEFAULT_PROMO_PIN_CONFIG: TPromoPinConfig = {
  activeZoomPin: 9,
  duration: 3200,
  activeZoomBalloon: 9,
  activeZoomBalloonDetails: 17,
  pulseRadius: 7,
};
